'use strict';

var formValidation = require('base/components/formValidation');

/**
 * Validates the reCAPTCHA for the given form and action.
 * Executes the callback function if reCAPTCHA is valid.
 *
 * @param {jQuery} form - The form element to validate.
 * @param {string} action - The action for reCAPTCHA validation (e.g., 'login', 'signup').
 * @param {Function} callback - The callback function to execute after reCAPTCHA validation.
 */
function validateRecaptcha(form, action, callback) {
    // Skip reCAPTCHA validation if not enabled
    if (!window.recaptchaPlugin || !window.recaptchaPlugin.ENABLED || !window.recaptchaPlugin.executeCaptcha) {
        return callback();
    }

    // Execute reCAPTCHA and handle the promise
    window.recaptchaPlugin.executeCaptcha(form, action).then(callback).catch(function () {
        $.spinner().stop();
    });
}

function resetLoginRecaptchaHolder($form) {
    $($form.find('.recaptcha-holder')[0]).remove();
    $form.append('<div class="recaptcha-holder"></div>');
}

function resendOTP(form) {
    $.ajax({
        url: form.data('action'),
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            $.spinner().stop();
            var $verifyAuthCodeBtnSlot = $('#auth-code-verify-btn-slot');
            var $verifyAuthCodeBtn = $('.auth-code-verify-btn');
            var $loginAuthSlot = $('#login-form-two-factor-auth-verification-slot');
            if (data.success) {
                $('.login-register-nav-container').hide();
                $('.login-form_credential-wrapper').hide();
                $verifyAuthCodeBtnSlot.removeClass('hide');
                $verifyAuthCodeBtn.show();
                $loginAuthSlot.html(data.otpTemplate);
                $('form.login').trigger('login:success', data);
            }
        },
        error: function (data) {
            if (data.responseJSON.redirectUrl) {
                window.location.href = data.responseJSON.redirectUrl;
            } else {
                $('form.login').trigger('login:error', data);
                $.spinner().stop();
            }
        }
    });
}

function sendOTP() {
    $(document).off('click', '.login-btn').on('click', '.login-btn', function (e) {
        var form = $('#login-form');
        e.preventDefault();
        var url = form.data('action');
        var $verifyAuthCodeBtn = $('.auth-code-verify-btn');
        var $authErrorMsg = $('#error-message-login-via-auth');
        if (form[0].checkValidity()) {
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    $.spinner().stop();
                    var $loginAuthSlot = $('#login-form-two-factor-auth-verification-slot');
                    var $verifyAuthCodeBtnSlot = $('#auth-code-verify-btn-slot');
                    var $lockoutErrorMsg = $('#error-message-lockout-via-auth');
                    var $errorMsgPhone = $('.error-message-phone');
                    $errorMsgPhone.addClass('d-none');
                    $authErrorMsg.addClass('d-none');
                    $lockoutErrorMsg.addClass('d-none');
                    var $loginForm = $('.login-form-content-section');
                    if (!data.success) {
                        window.dataLayer.push(data.dataLayer);
                        if (data.contactNotAvailable) {
                            $errorMsgPhone.removeClass('d-none');
                        } else if (data.attemptLeft) {
                            $authErrorMsg.removeClass('d-none');
                            $('#form-email-error').hide();
                            $('#form-password-error').hide();
                            $('form.login').trigger('login:error', data);
                            formValidation(form, data);
                        } else if (!data.attemptLeft) {
                            $authErrorMsg.addClass('d-none');
                            $loginForm.addClass('d-none');
                            $lockoutErrorMsg.removeClass('d-none').show();
                        }
                    } else {
                        $('.login-register-nav-container').hide();
                        $('.login-form_credential-wrapper').hide();
                        $verifyAuthCodeBtnSlot.removeClass('hide');
                        $verifyAuthCodeBtn.show();
                        $loginAuthSlot.html(data.otpTemplate);
                        $('form.login').trigger('login:success', data);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (jqXHR.responseJSON && jqXHR.responseJSON.redirectUrl) {
                        window.location.href = jqXHR.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', jqXHR);
                        $.spinner().stop();

                        window.dataLayer.push({
                            event: "custom.login",
                            group: "login",
                            category: 'user management',
                            action: "error",
                            label: "HTTP " + jqXHR.status + " - Server error",
                            method: "email"
                        });
                    }
                }
            });
        } else {
            $.spinner().stop();
            window.dataLayer.push({
                event: "custom.login",
                group:  "login",
                category: 'user management',
                action: "click",
                label: $('#form-email-error').text() || $('#form-password-error').text(),
                method: "email"
            });
        }
        return false;
    });
}

function sendRegistrationOTP() {
    $(document).off('click', '.create-account-btn').on('click', '.create-account-btn', function (e) {
        var form = $('.registration');
        e.preventDefault();
        var url = form.data('action');
        var $verifyAuthCodeBtn = $('.auth-code-verify-btn');
        if (form[0].checkValidity()) {
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    var $loginAuthSlot = $('#register-form-two-factor-auth-verification-slot');
                    var $verifyAuthCodeBtnSlot = $('#register-auth-code-verify-btn-slot');
                    var $errorMsgPhone = $('.error-message-phone');
                    $errorMsgPhone.addClass('d-none');
                    var $errorMsgExistingEmail = $('.error-message-existing-email');
                    $.spinner().stop();
                    if (data.emailExist) {
                        $errorMsgExistingEmail.html(data.errorMessage);
                        if (data.dataLayer && Array.isArray(data.dataLayer) && data.dataLayer.length > 0) {
                            window.dataLayer.push(data.dataLayer[0]);
                        }
                    } else if (!data.success) {
                        if (data.dataLayer && Array.isArray(data.dataLayer) && data.dataLayer.length > 0) {
                            window.dataLayer.push(data.dataLayer[0]);
                        }
                        if (data.contactNotAvailable) {
                            $errorMsgPhone.removeClass('d-none');
                        } else {
                            $('form.registration').trigger('login:register:error', data);
                            formValidation(form, data);
                        }
                    } else {
                        $('.login-register-nav-container').hide();
                        $('.register-form_credential-wrapper').hide();
                        $verifyAuthCodeBtnSlot.removeClass('hide');
                        $verifyAuthCodeBtn.show();
                        $loginAuthSlot.html(data.otpTemplate);
                        window.scrollTo({ top: 0, behavior: 'auto' });
                    }
                },
                error: function (data) {
                    $.spinner().stop();
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                    }
                }
            });
        } else {
            var messages = [];
            $('div.invalid-feedback:visible').each(function () {
                var text = $(this).text().trim();
                messages.push(text);
            });
            var finalMessage = messages.length == '1' ? messages[0] : messages.join(' | ');
            var selectedMethod = $('input[name="loginMethod"]:checked').val();
            dataLayer.push({
                event: "custom.registration",
                group: 'Signup',
                category: 'user management',
                action: "click",
                label: finalMessage,
                method: selectedMethod
            });
        }
        return false;
    });
}

function verifyOTP() {
    $(document).off('click', '.auth-code-verify-btn').on('click', '.auth-code-verify-btn', function (e) {
        var form = $(this).parents('form');
        e.preventDefault();
        var url = form.attr('action');
        if (form[0].checkValidity()) {
            $.spinner().start();
            validateRecaptcha(form, 'login', function () {
                $.ajax({
                    url: url,
                    type: 'post',
                    data: form.serialize(),
                    success: function (data) {
                        $.spinner().stop();
                        if (!data.success) {
                            $('form.login').trigger('login:error', data);
                            $('#verify-otp-vacant-error').hide();
                            var $otpErrorMsg = $('.otp-error-message');
                            $otpErrorMsg.removeClass('d-none');
                            resetLoginRecaptchaHolder(form);
                        } else {
                            $('form.login').trigger('login:success', data);
                            window.dataLayer.push(data.dataLayerObjLogin);
                            window.location.href = data.redirectUrl;
                            $('.login-success-message').removeClass('d-none').fadeIn();
                        }
                        setTimeout(function () {
                            $('.login-success-message').fadeOut(function () {
                                $(this).addClass('d-none');
                            });
                        }, 3000);
                    },
                    error: function (data) {
                        resetLoginRecaptchaHolder(form);
                        if (data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            $('form.login').trigger('login:error', data);
                            $.spinner().stop();
                        }
                    }
                });
            });
        } else {
            if (!$('#auth-form-code').val()) {
                $('#verify-otp-vacant-error').show();
            }
            $.spinner().stop();
        }
        return false;
    });
}

function verifyRegistrationOTP() {
    $(document).off('click', '.register-auth-code-verify-btn').on('click', '.register-auth-code-verify-btn', function (e) {
        var form = $('.registration');
        e.preventDefault();
        var url = form.attr('action');
        if (form[0].checkValidity()) {
            $.spinner().start();
            validateRecaptcha(form, 'signup', function () {
                $('form.registration').trigger('login:register', e);
                var separator = url.indexOf('?') >= 0 ? '&' : '?';
                url += separator + 'ischeckout=' + encodeURIComponent($('input[name="coregister"]').val() || '');
                $.ajax({
                    url: url,
                    type: 'post',
                    data: form.serialize(),
                    success: function (data) {
                        $.spinner().stop();
                        if (!data.success) {
                            var $otpErrorMsg = $('.otp-error-message');
                            formValidation(form, data);
                            $('form.login').trigger('login:error', data);
                            $('#verify-otp-vacant-error').hide();
                            $otpErrorMsg.removeClass('d-none');
                            window.dataLayer.push({
                                event: 'custom.registration',
                                group: 'signup',
                                category: '',
                                action: 'click',
                                label: 'Invalid OTP',
                                userId: '',
                                method: 'email'
                            });
                            resetLoginRecaptchaHolder(form);
                        } else {
                            $('form.login').trigger('login:success', data);
                            if (data.dataLayerObj && Array.isArray(data.dataLayerObj)) {
                                data.dataLayerObj.forEach(function(eventObj) {
                                    window.dataLayer.push(eventObj);
                                });
                            }
                            window.location.href = data.redirectUrl;
                        }
                    },
                    error: function (data) {
                        $.spinner().stop();
                        resetLoginRecaptchaHolder(form);
                        if (data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            $('form.login').trigger('login:error', data);
                        }
                    }
                });
            });
        } else {
            if (!$('#auth-form-code').val()) {
                $('#verify-otp-vacant-error').show();
            }
            $.spinner().stop();
        }
        return false;
    });
}

module.exports = {
    sendOTP: function () {
        sendOTP()
    },

    verifyOTP: function () {
        verifyOTP();
    },

    sendRegistrationOTP: function () {
        sendRegistrationOTP();
    },

    verifyRegistrationOTP: function () {
        verifyRegistrationOTP();
    },

    resendLoginOTP: function () {
        $(document).off('click', '.login-form-btn').on('click', '.login-form-btn', function (e) {
            var form = $('#login-form');
            e.preventDefault();
            resendOTP(form);
        });
    },

    resendRegistrationOTP: function () {
        $(document).off('click', '.registration-btn').on('click', '.registration-btn', function (e) {
            var form = $('.registration');
            e.preventDefault();
            resendOTP(form);
        });
    },

    resendCheckoutFlowLoginOTP: function () {
        $(document).off('click', '.registered-customer-btn').on('click', '.registered-customer-btn', function (e) {
            var form = $('#registered-customer');
            e.preventDefault();
            resendOTP(form);
        });
    }
};
